var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-screen',{staticClass:"screen-register",attrs:{"is-natural":true,"id":"app","loading":_vm.is.loading}},[(!_vm.is.loading)?_c('router-view',{key:_vm.$path}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }